"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSsrCasinoFavorites = void 0;
const withSsrCasinoFavorites = (client, mobile) => {
    return client.findCasinoFavoriteByUserId(mobile);
};
exports.withSsrCasinoFavorites = withSsrCasinoFavorites;
//# sourceMappingURL=casino.favorites.js.map